import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Card, Row, Input, CardBody } from "reactstrap";
import { API_Web_RTC } from "../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../helpers/AxiosAPI";
import DialPad from "../Components/dialPad";
import JsSIP from 'jssip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignRight, faCut, faPause, faPhone } from "@fortawesome/free-solid-svg-icons";
import Luna from '../../../../../assets/audio/luna_docs.wav';
import phone_suite_calling_party from './../../../../../assets/phone_suite_calling_party.png';
function WebRTC({ webRTCIntegration, handleBackToChat, propertyId, isOncall, number, rtcNumber }) {
    var callOptions = {
        mediaConstraints: { audio: true, video: false },
        mandatory: [
            {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: false,
            },
        ],
    };
    var incomingCallAudio = new Audio(Luna);
    incomingCallAudio.loop = true;
    incomingCallAudio.crossOrigin = "anonymous";
    let audioElement = new Audio();
    const [isMymaPhoneValid, setIsMymaPhoneValid] = useState(false);
    const [msg, setMsg] = useState();
    const [visible, setVisible] = useState();
    const [isOnMute, setIsOnMute] = useState(false);
    const [isOnHold, setIsOnHold] = useState(false);
    const [isCallConfirmed, setIsCallConfirmed] = useState();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [waitForConnection, setWaitForConnection] = useState(false);
    const [currentSession, setCurrentSession] = useState();
    const [isCallComing, setIsCallComing] = useState(false);
    //DialPad
    const [showDialPad, setShowDialPad] = useState(false);
    const [mymaPhone, setMymaPhone] = useState();
    // Dial Pad Toggle

    const dialPadToggle = () => {
        setShowDialPad(!showDialPad);
    };

    const handlePhoneNumber = (val) => {
        setPhoneNumber(val);
    };

    useEffect(() => {
        if (webRTCIntegration !== undefined) {
            var bwPhone = new JsSIP.UA({
                sockets: [
                    new JsSIP.WebSocketInterface("wss://core1-atl.ucsandbox.net:9002"),
                ],
                uri: webRTCIntegration?.sipUrl,
                password: webRTCIntegration?.sipPassword,
                // no_answer_timeout: 30,
                display_name: "",
                register: true,
            });



            bwPhone.start();
            bwPhone.on("connected", function (e) {
                console.log(e, "Connected");
            });

            bwPhone.on("registered", function (e) {
                console.log(e, "registered");
                //handleIsOnCall(true);
            });

            bwPhone.on("newMessage", function (e) {
                console.log(e);
                if (e.originator === "local") {
                    var msg = e.message;
                    msg.on("succeeded", function (e) {
                        console.log("Sended Successfully");
                    });

                    msg.on("failed", function (e) {
                        //the call has ended
                        console.log("Failed", e);
                    });
                } else if (e.originator === "remote") {
                    var msg = e.message;
                    var request = e.message._request;
                    console.log("Message: ", request.body);
                    console.log("From: ", request.from._display_name);
                    // msg.accept();
                }
            });



            setMymaPhone(bwPhone);
        }

        return () => {

        };
    }, [propertyId]);

    useEffect(() => {
        if (mymaPhone !== undefined) {
            mymaPhone.on("newRTCSession", function (e) {
                var session = e.session;
                if (e.originator === "local") {
                    session.on("confirmed", function (e) {
                        setIsCallConfirmed(true);
                        setCurrentSession(session);
                    });

                    session.on("accepted", function (e) {
                        setIsCallConfirmed(true);
                        setWaitForConnection(false);
                        setCurrentSession(session);
                    });
                } else if (e.originator === "remote") {
                    setCurrentSession(session);
                    session.on("confirmed", function (e) {
                        console.log("confirmed", e);
                        setIsCallConfirmed(true);
                        setCurrentSession(session);
                        var localStream = session.connection.getLocalStreams()[0];
                        console.log(localStream.getAudioTracks(), localStream.getTracks());

                        var dtmfSender = session.connection.createDTMFSender(
                            localStream.getAudioTracks()[0]
                        );
                        session.sendDTMF = function (tone) {
                            dtmfSender.insertDTMF(tone);
                        };
                    });

                    session.on("accepted", function (e) {
                        console.log("accepted", e);
                        setIsCallConfirmed(true);
                        setWaitForConnection(false);
                        setCurrentSession(session);
                    });
                    setIsCallComing(true);
                }

                session.on("ended", function (e) {
                    console.log(e);
                    setIsCallConfirmed(false);
                    if (currentSession !== undefined)
                        currentSession.terminate();
                    setCurrentSession();
                    setIsCallComing(false);
                    setWaitForConnection(false);
                });

                session.on("failed", function (e) {
                    console.log(e);
                    setIsCallConfirmed(false);
                    if (currentSession !== undefined)
                        currentSession.terminate();
                    setCurrentSession();
                    setWaitForConnection(false);
                    setIsCallComing(false);
                });

                session.on("peerconnection", (e) => {
                    console.log("peerconnection", e.peerconnection);

                    session.connection.addEventListener("addstream", function (e) {
                        audioElement.srcObject = e.stream;
                        audioElement.play();
                        //remoteView.srcObject = e.stream;
                        // selfView.srcObject = (session.connection.getLocalStreams()[0]);
                    });
                    const peerconnection = e.peerconnection;
                    // peerconnection.onaddstream = function (e) {
                    //   console.log("addstream", );
                    //   const mediaStream = new MediaStream();
                    //   //mediaStream.addTrack(e.stream);
                    //   audioElement.current.srcObject = e.stream;
                    //   audioElement.current.play();
                    // };
                });

                if (session.direction === "incoming") {
                    // incomingCallAudio.play();
                } else {
                    console.log("con", session.connection);
                    session.connection.addEventListener("addstream", function (e) {
                        audioElement.srcObject = e.stream;
                        audioElement.play();
                    });
                }
            });
        }
    }, [mymaPhone]);


    useEffect(() => {
        if (number !== undefined && number !== null && number !== '') {
            setShowDialPad(false);
            setPhoneNumber(number);
            // if (mymaPhone !== undefined && mymaPhone.isConnected()) {
            //     var session = mymaPhone.call(number, callOptions);
            //     setWaitForConnection(true);
            // }
        }
    }, [number]);

    useEffect(() => {
        if (rtcNumber !== undefined && rtcNumber !== '') {
            setPhoneNumber(rtcNumber);
        }
    }, [rtcNumber]);

    const handleBack = () => {
        if (mymaPhone !== undefined)
            mymaPhone.terminateSessions();
        handleBackToChat();
    }

    const handleMute = () => {
        if (isOnMute) {
            if (currentSession !== undefined) {
                currentSession.unmute({ audio: true });
                console.log("Call is unmute now");
            }
        } else {
            if (currentSession !== undefined) {
                currentSession.mute({ audio: false });
                console.log("Call is mute now");
            }
        }
        setIsOnMute(!isOnMute);
    };

    const handleHold = () => {
        if (isOnHold) {
            if (currentSession !== undefined) {
                currentSession.unhold();
                console.log("Call is unhold now");
            }
        } else {
            if (currentSession !== undefined) {
                currentSession.hold();
                console.log("Call is hold now");
            }
        }
        setIsOnHold(!isOnHold);
    };

    const handleCallDisconnect = () => {
        if (currentSession !== undefined) {
            currentSession.terminate();
            setIsCallComing(false);
        }
    };

    const handleCallAceept = () => {
        if (currentSession !== undefined) {
            currentSession.answer(callOptions);
        }
        setIsCallComing(false);
    };

    const handleCall = () => {
        setShowDialPad(false);
        if (phoneNumber === "") {
            setMsg("Number is not valid.");
            setVisible(true);
        } else {
            if (mymaPhone !== undefined && mymaPhone.isConnected()) {
                var session = mymaPhone.call(phoneNumber, callOptions);
                setWaitForConnection(true);
            }
        }
    };

    return (
        <Fragment>
            {(isOncall !== undefined && isOncall === true) && <Fragment>
                <audio src={audioElement} playsInline id="audio-element"></audio>
                <Row className="px-0 mx-2 my-1">
                    {isCallConfirmed && (
                        <Input
                            type="text"
                            value={"Currently on a voice call"}
                            disabled
                            style={{ width: "50%" }}
                        ></Input>
                    )}
                    {waitForConnection && (
                        <Input
                            type="text"
                            value={"Please wait till connection"}
                            disabled
                            style={{ width: "50%" }}
                        ></Input>
                    )}
                    {!waitForConnection && !isCallConfirmed && (
                        <Input
                            type="text"
                            value={phoneNumber}
                            disabled
                            style={{ width: "65%" }}
                        ></Input>
                    )}

                    {/* <Button
                        size="xs"
                        outline
                        color="primary"
                        className="ml-1 btn-round"
                        onClick={dialPadToggle}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            style={{ fill: "rgba(0, 0, 0, 1)" }}
                        >
                            <circle cx="12" cy="6" r="2"></circle>
                            <circle cx="6" cy="6" r="2"></circle>
                            <circle cx="18" cy="6" r="2"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                            <circle cx="6" cy="12" r="2"></circle>
                            <circle cx="18" cy="12" r="2"></circle>
                            <circle cx="12" cy="18" r="2"></circle>
                        </svg>
                    </Button> */}

                    <Button
                        size="xs"
                        outline
                        color="primary"
                        className="ml-1 btn-round rtc"
                        style={{
                            display: `${isCallConfirmed && isOnMute ? "block" : "none"}`,
                        }}
                        onClick={handleMute}
                    >

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            style={{ fill: "var(--theme-color-1)" }}
                        >
                            <path d="m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"></path>
                            <path d="M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"></path>
                        </svg>
                    </Button>
                    <Button
                        size="xs"
                        outline
                        color="primary"
                        className="ml-1 btn-round"
                        style={{
                            display: `${isCallConfirmed && !isOnMute ? "block" : "none"}`,
                        }}
                        onClick={handleMute}
                    >
                        <i className="demo-icon iconsminds-microphone-4"></i>
                    </Button>

                    <Button
                        size="xs"
                        outline={isOnHold ? true : false}
                        color="primary"
                        className="ml-1 btn-round"
                        style={{
                            pointerEvents: 'none',
                            display: `${isCallConfirmed ? "block" : "none"}`,
                        }}
                        onClick={handleHold}
                    >
                        <FontAwesomeIcon
                            icon={faPause}
                        ></FontAwesomeIcon>
                    </Button>
                    {/* <Button
                        size="xs"
                        outline={!isOnHold ? true : false}
                        color="primary"
                        className="ml-1 btn-round rtc"
                        style={{
                            pointerEvents: 'none'
                            //  display: `${isCallConfirmed && !isOnHold ? "block" : "none"}`,
                        }}
                        onClick={handleHold}
                    >
                        <FontAwesomeIcon
                            icon={faPause}
                        ></FontAwesomeIcon>
                    </Button> */}

                    <Button
                        size="xs"
                        id="callHangUp"
                        style={{ display: `${isCallConfirmed ? "block" : "none"}` }}
                        onClick={handleCallDisconnect}
                        className="ml-1 btn-round"
                        outline
                        color="primary"
                    >
                        <FontAwesomeIcon
                            icon={faPhone}
                            style={{ transform: "rotate(220deg)" }}
                        ></FontAwesomeIcon>
                    </Button>

                    <Button
                        size="xs"
                        id="connectCall"
                        style={{ display: `${!isCallConfirmed ? "block" : "none"}` }}
                        onClick={handleCall}
                        className="ml-1 btn-round"
                        outline
                        color="primary"
                    >
                        <img src={phone_suite_calling_party} style={{ height: '1rem' }}></img>
                    </Button>

                    <Button
                        size="xs"
                        outline
                        color="primary"
                        className="mx-1 btn-round"
                        onClick={handleBack}
                    >
                        <i className="iconsminds-back" style={{}}></i>
                    </Button>
                </Row>
                {showDialPad && (
                    <DialPad
                        isvisible={showDialPad}
                        //isOnCall={isOnCall}
                        toggle={dialPadToggle}
                        handlePhoneNumber={handlePhoneNumber}
                    ></DialPad>
                )}
            </Fragment>}

            <Modal isOpen={visible} toggle={() => setVisible(false)}>
                <ModalHeader toggle={() => setVisible(false)}>Error</ModalHeader>
                <ModalBody>
                    <h6 className="m-2">{msg}</h6>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setVisible(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isCallComing} toggle={() => setIsCallComing(false)}>
                <ModalHeader toggle={() => setIsCallComing(false)}>
                    Incoming Call
                </ModalHeader>
                <ModalBody>
                    {currentSession !== undefined && <h6 className="m-2">{currentSession.remote_identity._display_name} is calling ... </h6>}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleCallAceept}>
                        Accept
                    </Button>
                    <Button color="danger" onClick={handleCallDisconnect}>
                        Decline
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default
    connect(mapStateToProps, {
    })(WebRTC);